import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { MessageDto } from "../../../dto/GenApi.iNotPaie.Dto/MessageDto";

@Component
export default class ModalModifExercice extends Vue {
	public messages: MessageDto[] = [];

	public Init(): void {
    	ServicesFactoryInstance.ExercicesService.getMessages("G", 0, data => {
    		if (data != null) {
    			this.messages = data;
    		}
    	});
	}

	public supprimer(id: number): void {
    	ServicesFactoryInstance.ExercicesService.deleteMessage(id);
    	$("#modalModifExercice").modal("hide");
	}

	public annuler(): void {
    	$("#modalModifExercice").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/exercices/modalModifExercice/modalModifExercice.ts